import bocapioCakeService from "@/services/cakephp"
import nodeService from "@/services/nodejs"

const getAllAgents = async ({ commit }, params) => {
  try {
    var agent = undefined
    if(params == undefined){
      agent = JSON.parse(localStorage.getItem('cakeuserdata')).user.uuid || JSON.parse(localStorage.getItem('cakeuserdata')).place.janooUserUuid
    }
    else{
      agent = params
    }

    const { list } = await bocapioCakeService.getAgents(agent)
    commit('LIST_ALL_AGENTS', list)
  }
  catch (error) {
  }
}

const getAgentByUUID = async ({ commit }, uuid) => {
  try {
    const agent = await bocapioCakeService.getAgentByUUID(uuid)
    return agent
  }
  catch (error) {
  }
}

const checkExpressBooking = (state, payload) => {
  nodeService.postCheckinExpressBooking(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const addBookingAgent = async (state, payload) => {
  await nodeService.postAddBookingAgent(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const removeBookingAgent = async (state, payload) => {
  await nodeService.postRemoveBookingAgent(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const cancelExpressBooking = async (state, payload) => {
  await nodeService.postCancelExpressBooking(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const updateExpressBookingDate = (state, payload) => {
  nodeService.postUpdateExpressBookingDate(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

// /**
//  * Carrega lista de POIs (atrativos) do {{ USER_UUID }}
//  * @param {*} state
//  * @param {*} USER_UUID
//  */
// const fetchProductsList = async (state, USER_UUID) => {
//   state.commit('RESET_PRODUCT_LIST')

//   await nodeService.getPoisByVendor(USER_UUID)
//     .then(response => {
//       state.commit('SET_PRODUCT_LIST', response.data)
//     })
// }

export default {
  getAllAgents,
  getAgentByUUID,
  addBookingAgent,
  removeBookingAgent,
  checkExpressBooking,
  cancelExpressBooking,
  updateExpressBookingDate,
  // fetchProductsList,
}
